import React,{useEffect,useState} from 'react';
import {appGetUrlPath} from '../function_lib/common_lib';
import user_default from '../assets/images/user_icon.png';
import './comp_popeup_profile_viewer.css'

const Comp_Popup_Profile_Viewer=(props)=>{
  let appUrlMedPath=appGetUrlPath();
  const [getViewContacts,setViewContacts]=useState(0);
  //let getViewContacts=0;
   useEffect(()=>{
      if(typeof props.profileData.req_status!=="undefined"){
        if(props.profileData.req_status==="Accepted"){
          setViewContacts(1);
          //getViewContacts=1;
        }else{
          setViewContacts(0);
        }
      }else{
        setViewContacts(0);
      }
   },[props.profileData,getViewContacts])
    return(
      <div class="modal fade popup_profile_viewer_khandelwal_parinay" id="profileModal" tabindex="-1" aria-labelledby="profileModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-lg-custom text-start">
          <div class="modal-content">
            <button type="button" class="close-btn" data-bs-dismiss="modal" aria-label="Close">
              &times;
            </button>

            <div class="modal-body p-0">
              <div class="d-flex flex-column flex-md-row">
                <div class="modal-image-section col-md-5">
                  <div class="profile-image-container">
                    <img src={props.profileData?.pro_pic===""?user_default:appUrlMedPath+props.profileData?.pro_pic} class="img-fluid"/>
                    <div class="verified-tickmark">Verified</div>
                  </div>
                  <div class="basic-details">
                    <p><strong>Member Id:</strong> {props.profileData?.account_info_id}</p>
                    <p><strong>Name:</strong> {props.profileData?.mem_name}</p>
                    <p><strong>Email:</strong>{getViewContacts===1?props.profileData?.email_id:"****"}</p>
                    <p><strong>Mobile:</strong>{getViewContacts===1?props.profileData?.contact_no:"****"}</p>
                  <p><strong>Address:</strong>{props.profileData?.address}</p>
                  </div>
                </div>
                <div class="gallery-container col-md-7">
                        <div class="gallery-title">Gallery</div>
                        <div class="row">
                        {props.profileData?.other_pic?.split(',').map((itemPic,picIndex)=>{
                if(itemPic!==""){
                    return <div class="col-4 col-md-3">
                        <img class="gallery-image" src={appUrlMedPath+itemPic} />
                    </div>
                }
               
              })}
                          
                        </div>
                      </div>
              </div>
              
              <div class="d-flex flex-column flex-md-row">
              <div class="text-section w-100 w-md-35">
                  <h3 class="section-title">Personal Details</h3>
                  <p><strong>Gender:</strong> {props.profileData?.gender}</p>
                  <p><strong>Date of Birth:</strong> {props.profileData?.fmt_dob}</p>
                  <p><strong>Birth Time:</strong> {props.profileData?.fmt_time}</p>
                  <p><strong>Birth Place:</strong> {props.profileData?.birth_place}</p>
                  <p><strong>Height:</strong> {props.profileData?.height} cm</p>
                  <p><strong>Skin Color:</strong> {props.profileData?.skin_color}</p>
                  <p><strong>Marital Status:</strong>{props.profileData?.marital_status}</p>
                  <p><strong>Manglik Status:</strong>{props.profileData?.manglik_status}</p>
                </div>
                
               
                <div class="text-section w-100 w-md-35">
                  <h3 class="section-title">Professional Details</h3>
                  <p><strong>Highest Qualification:</strong>{props.profileData?.max_qualification} / {props.profileData?.max_qualification_det}</p>
                  <p><strong>Occupation:</strong>{props.profileData?.occupation}</p>
                  <p><strong>Self Annual Income:</strong> {props.profileData?.self_anum} LPA</p>            
                  <p><strong>Family Annual Income:</strong> {props.profileData?.family_anum} LPA</p>
                  <p><strong>Goutra:</strong> {props.profileData?.self_goutra}</p>
                  <p><strong>Maternal Goutra:</strong>{props.profileData?.mama_goutra}</p>
                </div>
                <div class="text-section w-100 w-md-35">
                  <h3 class="section-title">Family Details</h3>
                  <p><strong>Father's Name:</strong>{props.profileData?.father_nm}</p>
                  <p><strong>Mother's Name:</strong> {props.profileData?.mother_name}</p>
                  <p><strong>Father's Occupation:</strong>{props.profileData?.father_occup}</p>
                  <p><strong>Father's Mobile:</strong>{getViewContacts===1?props.profileData?.father_contact:"****"}</p>
                  <p><strong>Mother's Occupation:</strong>{props.profileData?.mother_occup}</p>
                  <p><strong>Mother's Mobile:</strong>{getViewContacts===1?props.profileData?.mother_contact:"****"}</p>
                  {/* <p><strong>Brother:</strong> No brothers</p>
                  <p><strong>Sister:</strong> No Sisters</p> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
//  </div>
    );
}
export default Comp_Popup_Profile_Viewer;
